import { sbaAxios } from "../utils/sbaAxios";
import { getTaxEntityDetailsAPI, getTaxEntityListAPI, getInvestorActivities, getContactRelatedContacts, getContactRelationTypes } from "../../config/apiConfig";
import {
    FETCH_TAXENTITYLIST_BEGIN, FETCH_TAXENTITYLIST_SUCCESS, FETCH_TAXENTITYLIST_FAILURE,
    FETCH_TAXENTITYDETAIL_BEGIN, FETCH_TAXENTITYDETAIL_SUCCESS, FETCH_TAXENTITYDETAIL_FAILURE,
    FETCH_INVESTORACTIVITYDETAIL_BEGIN, FETCH_INVESTORACTIVITYDETAIL_SUCCESS, FETCH_INVESTORACTIVITYDETAIL_FAILURE,
    FETCH_RELATEDCONTACT_BEGIN, FETCH_RELATEDCONTACT_SUCCESS, FETCH_RELATEDCONTACT_FAILURE,
    FETCH_RELATIONTYPES_BEGIN, FETCH_RELATIONTYPES_SUCCESS, FETCH_RELATIONTYPES_FAILURE,


} from "../constants/investorAccount";


export const getTaxEntityListAction=(searchTerms)=>{
    return (dispatch) => {
        dispatch(fetchInvestorAccountsBegin());
        const FormattedURL = !searchTerms ? getTaxEntityListAPI : `${getTaxEntityListAPI}${searchTerms}` ;
        sbaAxios({
            url: FormattedURL,
            method: 'get',
        })
        .then((repos) => {
          const List = repos;
          dispatch(fetchInvestorAccountsSuccess(List));
          return List;
        })
        .catch((error) => {return dispatch(fetchInvestorAccountsFailure(error))});
    };
  }
  
  export const fetchInvestorAccountsBegin = () => ({
    type:  FETCH_TAXENTITYLIST_BEGIN,
  });
  
  export const fetchInvestorAccountsSuccess = (investorAccountsList) => ({
    type: FETCH_TAXENTITYLIST_SUCCESS,
    payload: {investorAccountsList},
  });
  
  
  export const fetchInvestorAccountsFailure = (errorMessage) => ({
    type: FETCH_TAXENTITYLIST_FAILURE,
    payload: {errorMessage}
  });



  
export const getTaxEntityDetailAction=(entityID)=>{
  return (dispatch) => {
      dispatch(fetchInvestorAccountDetailBegin());
      sbaAxios({
          url:`${getTaxEntityDetailsAPI}${entityID}`,
          method: 'get',
      })
      .then((repos) => {
        const AccountDetails = repos;
        dispatch(fetchInvestorAccountDetailSuccess(AccountDetails));
        return AccountDetails;
      })
      .catch((error) => {return dispatch(fetchInvestorAccountDetailFailure(error))});
  };
};
export const fetchInvestorAccountDetailBegin = () => ({
  type:  FETCH_TAXENTITYDETAIL_BEGIN,
});
export const fetchInvestorAccountDetailSuccess = (investorAccountDetail) => ({
  type: FETCH_TAXENTITYDETAIL_SUCCESS,
  payload: {investorAccountDetail},
});
export const fetchInvestorAccountDetailFailure = (errorMessage) => ({
  type: FETCH_TAXENTITYDETAIL_FAILURE,
  payload: {errorMessage}
});

export const getInvestorActivitiesAction = (contactId, accountTypeIds, activiyTypeIds, startDate, endDate, activitySubTypeIds, subject) => {
    return (dispatch) => {
        dispatch(fetchInvestorActivitiesBegin());
        sbaAxios({
            url: `${getInvestorActivities}?contactId=${contactId}&accountIds=${accountTypeIds}&activiyTypeIds=${activiyTypeIds}&startDate=${startDate}&endDate=${endDate}&activitySubTypeIds=${activitySubTypeIds}&subject=${subject}`,
            method: 'get',
        })
            .then((repos) => {
                const InvestorActivitiesDetails = repos;
                dispatch(fetchInvestorActivitiesSuccess(InvestorActivitiesDetails));
                return InvestorActivitiesDetails;
            })
            .catch((error) => { return dispatch(fetchInvestorActivitiesFailure(error)) });
    };
}



export const fetchInvestorActivitiesBegin = () => ({
    type: FETCH_INVESTORACTIVITYDETAIL_BEGIN,
});

export const fetchInvestorActivitiesSuccess = (InvestorActivitiesDetails) => ({
    type: FETCH_INVESTORACTIVITYDETAIL_SUCCESS,
    payload: { InvestorActivitiesDetails },
});
export const fetchInvestorActivitiesFailure = (errorMessage) => ({
    type: FETCH_INVESTORACTIVITYDETAIL_FAILURE,
    payload: { errorMessage }
});


export const getContactRelatedContactsAction = (contactID) => {
    return (dispatch) => {
        dispatch(fetchContactRelatedContactDetailBegin());
        sbaAxios({
            url: `${getContactRelatedContacts}${contactID}`,
            method: 'get',
        })
            .then((repos) => {
                const RelatedContact = repos;
                dispatch(fetchContactRelatedContactDetailSuccess(RelatedContact));
                return RelatedContact;
            })
            .catch((error) => { return dispatch(fetchContactRelatedContactDetailFailure(error)) });
    };
};
export const fetchContactRelatedContactDetailBegin = () => ({
    type: FETCH_RELATEDCONTACT_BEGIN,
});
export const fetchContactRelatedContactDetailSuccess = (RelatedContact) => ({
    type: FETCH_RELATEDCONTACT_SUCCESS,
    payload: { RelatedContact },
});
export const fetchContactRelatedContactDetailFailure = (errorMessage) => ({
    type: FETCH_RELATEDCONTACT_FAILURE,
    payload: { errorMessage }
});

export const getContactRelationTypesAction = () => {
    return (dispatch) => {
        dispatch(fetchgetContactRelationTypesBegin());
        sbaAxios({
            url: `${getContactRelationTypes}`,
            method: 'get',
        })
            .then((repos) => {
                const RelationTypes = repos;
                dispatch(fetchgetContactRelationTypesSuccess(RelationTypes));
                return RelationTypes;
            })
            .catch((error) => { return dispatch(fetchgetContactRelationTypesFailure(error)) });
    };
};
export const fetchgetContactRelationTypesBegin = () => ({
    type: FETCH_RELATIONTYPES_BEGIN,
});
export const fetchgetContactRelationTypesSuccess = (RelationTypes) => ({
    type: FETCH_RELATIONTYPES_SUCCESS,
    payload: { RelationTypes },
});
export const fetchgetContactRelationTypesFailure = (errorMessage) => ({
    type: FETCH_RELATIONTYPES_FAILURE,
    payload: { errorMessage }
});